"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EditorTopMenuBarModule = /** @class */ (function () {
    function EditorTopMenuBarModule() {
    }
    return EditorTopMenuBarModule;
}());
exports.EditorTopMenuBarModule = EditorTopMenuBarModule;
